import { ACTIONS } from '../../constants';
import { createState } from './fieldCreaters';
import { IFieldState, TFieldActions } from './types';

const initialState: IFieldState = {
  maxLength: -1,
  disabled: false,
  hidden: true,
  placeholder: '',
  value: '',
  attachFile: false,
  multiline: false,
  nodeId: undefined,
  change: false,
};

export const fieldReducer = (
  state = initialState,
  action: TFieldActions,
): IFieldState => {
  switch (action.type) {
    case ACTIONS.FIELD_CHANGE_VALUE: {
      return {
        ...state,
        value: action.value,
      };
    }

    case ACTIONS.FIELD_UPDATE_CHATBOT: {
      return createState(action.data);
    }

    case ACTIONS.FIELD_UPDATE_LIVE_CHAT: {
      return {
        ...state,
        nodeId: action.data.nodeId,
        placeholder: action.data.placeholder,
      };
    }
    case ACTIONS.SEND_MESSAGE: {
      return {
        ...state,
        disabled: true,
        value: '',
        attachFile: false,
        multiline: false,
        change: false,
      };
    }

    case ACTIONS.CHAT_RESET: {
      return createState(initialState);
    }

    default: {
      return state;
    }
  }
};
